import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useToast } from "hooks/useToast";
import SpinnerIcon from "components/lib/Shared/Icons/SpinnerIcon";
import ApplicationReviewTab from "components/PLCTABS/ApplicationReviewTab";
import { getComments, resetCommentsSlice } from "state/slices/comment";
import { getCompany, reset } from "state/slices/company";
import { getTransactionChangeByIdAsync } from "state/slices/initiateTransactionChange";
import OfficialSubRow from "components/CompanyDashboard/MaintainYourCompany/Review/OfficialSubRow";
import TransactionReviewTab from "components/TransactionReviewTab";
import { getTransactionUnderReviewAsync } from "state/slices/transaction";
import TransferYourBusinessReviewTab from "components/TransferYourBusinessReviewTab";
import OrgAdminSubRowAsync from "components/SystemAdminDashboard/SubRowAsync";

function SubRowAsync({ visibleColumns, row, refreshTableData }) {
  const dispatch = useDispatch();
  const { toast } = useToast(5000);

  const { company, getCompanyStatus } = useSelector(
    (state) => state.companySlice
  );
  const { transactionUnderReview, getTransactionUnderReview } = useSelector(
    (state) => state.transactionSlice
  );

  // Fetch data based on row type (OFFICIAL or COMPANY)
  useEffect(() => {
    if (row.original?.isOrgAdmin) return;
    if (row?.original?.applicationType) {
      dispatch(getTransactionUnderReviewAsync({ trxId: row.original._id }));
      dispatch(getComments({ companyId: row.original.companyInfo._id }));
      dispatch(getCompany({ id: row.original.companyInfo._id }));
    } else {
      dispatch(getCompany({ id: row.original._id }));
      dispatch(getComments({ companyId: row.original._id }));
    }

    return () => {
      dispatch(reset());
      dispatch(resetCommentsSlice());
    };
  }, [dispatch, row?.original]);

  useEffect(() => {
    if (getCompanyStatus?.status === "failed" && getCompanyStatus.error) {
      toast("error", getCompanyStatus.error);
      row.toggleRowExpanded();
    }
  }, [getCompanyStatus.status, getCompanyStatus.error, row, toast]);

  if (row.original?.isOrgAdmin) {
    return <OrgAdminSubRowAsync visibleColumns={visibleColumns} row={row} />;
  }

  if (
    (!row?.original?.applicationType &&
      (!company?._id || getCompanyStatus?.status === "loading")) ||
    (row?.original?.applicationType &&
      getTransactionUnderReview?.status === "loading")
  ) {
    return (
      <tr className="bg-[#EDF0F5]">
        <td colSpan={visibleColumns.length} className="px-9">
          <div className="flex justify-center mx-auto my-4">
            <SpinnerIcon className="text-gray-400" />
          </div>
        </td>
      </tr>
    );
  }

  const handleBackBtn = () => {
    row.toggleRowExpanded();
    refreshTableData();
  };

  return (
    <tr className="bg-[#EDF0F5]">
      <td colSpan={visibleColumns.length} className="p-8 max-w-lg">
        {row.original?.applicationType &&
          transactionUnderReview?.items?.transactions?.length > 0 ? (
          <div>
            <TransactionReviewTab
              isFromAdmin={true}
              handleBackBtn={handleBackBtn}
            />
          </div>
        ) : row.original?.transferYourBusinessInitiator ? (
          <div>
            <TransferYourBusinessReviewTab handleBackBtn={handleBackBtn} />
          </div>
        ) : (
          <div>
            <ApplicationReviewTab handleBackBtn={handleBackBtn} />
          </div>
        )}
      </td>
    </tr>
  );
}

export default SubRowAsync;
